import IllustratedInfoCard, {
  AppearanceProps,
  Title,
  Paragraph,
  LogoWrapper,
} from '../../../components/cards/IllustratedInfoCard'
import Logo from '../../../components/icons/BrandIconPositive'

import { LearnMoreLink } from '../shared'

import { image as defaultImage } from './content'

type AboutRiparideProps = {
  image?: { medium: string; large: string }
  noLogo?: boolean
} & AppearanceProps

const AboutRiparide = ({
  image = defaultImage,
  noLogo,
  vertical,
  inverseColors,
}: AboutRiparideProps) => {
  return (
    <IllustratedInfoCard
      image={image}
      alt="The Riparide Story"
      vertical={vertical}
      inverseColors={inverseColors}
    >
      <Title>The Riparide Story</Title>
      <Paragraph>
        Riparide exists to inspire you to unplug from modern-day trappings and
        find fulfillment in nature. Why? Because time in nature fills the soul.
      </Paragraph>
      <LearnMoreLink to="/about" inverse={!inverseColors}>
        Learn more
      </LearnMoreLink>

      {!noLogo && (
        <LogoWrapper inverseColors={inverseColors}>
          <Logo />
        </LogoWrapper>
      )}
    </IllustratedInfoCard>
  )
}

export default AboutRiparide
